<div
  class="main-page"
  [class.edit-mode]="isEditPhoneMode"
  [class.desktop-wrapper]="isEditPhoneMode && isDesktop"
>

<button class="button back-btn" *ngIf="isVerificationStep" (click)="isVerificationStep = false">
  <img src="assets/images/icons/left-arrow.svg" alt="back to login button">
</button>

  <div class="desktop-image-container" *ngIf="!isEditPhoneMode">
    <div class="image-wrapper">
      <h2>anywhere, anytime</h2>
      <p>buy, send and gift cards, all with a few Clicks in the kingiftcard.</p>
    </div>
    <img src="assets/images/login-image.png" alt="login image">
  </div>
  <div
    class="container"
    [class.desktop-background]="isDesktop && !isEditPhoneMode"
  >


    <div
      class="login-header"
      [class.verify-header]="isVerificationStep"
      *ngIf="!isEditPhoneMode"
    >
      <img src="assets/images/kingift-logo-mobile.png" alt="kingift logo" />
      <h3 *ngIf="!isVerificationStep">Welcome Back</h3>
      <p [class.verify-description]="isVerificationStep">
        {{
          isVerificationStep
            ? "We've sent you a verification code"
            : 'Log in below to access your kingiftcard Account'
        }}
      </p>
    </div>
    <div class="verification-container" [hidden]="isVerificationStep">
      <form
        [formGroup]="smsLoginForm"
        (ngSubmit)="submitPhoneNumber()"
        class="sms-login-form"
      >
        <div class="country-number-field" *ngIf="filteredCountryList">
          <mat-form-field class="country-field">
            <mat-select
              formControlName="country_field"
              [(value)]="selected"
              (openedChange)="clearSearchField()"
              class="phone-country-select-trigger"
              panelClass="phone-field-select"
            >
              <mat-select-trigger class="trigger">
                <div class="country-info flex">
                  <img
                    [src]="selected.image"
                    *ngIf="selected?.image"
                    class="selected-img"
                  />
                  <span class="phone-number-field">{{
                    selected?.phone_prefix
                  }}</span>
                </div>
              </mat-select-trigger>
              <mat-form-field class="mat-select-search" appearance="outline">
                <input
                  matInput
                  type="text"
                  placeholder="Search..."
                  formControlName="country_search"
                  autocomplete="off"
                />
                <img
                  src="assets/images/icons/search-country.svg"
                  alt=""
                  matSuffix
                />
              </mat-form-field>
              <mat-option
                [value]="country"
                *ngFor="let country of filteredCountryList"
                class="country-option"
              >
              <label class="country-radio-label">
                <input [checked]="smsLoginForm.get('country_field').value.id == country.id" type="radio" name="radio" />
                <span class="country-container">
                  <img [src]="country.image" />
                  <span class="country-name">
                    <span>{{ (country.name | slice: 0 : 16) || '-' }} {{country.name?.length > 16 ? '...' : ''}}</span>
                  </span>
                </span>
              </label>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="numberfield" hideRequiredMarker="true">
            <input
              matInput
              onlyNumbers
              formControlName="number"
              type="number"
              maxlength="15"
              pattern="[0-9]*"
              placeholder="Your Phone Number"
              class="phone-number-field"
            />
          </mat-form-field>
        </div>
        <div style="height: 78px;">
          <div id="recaptcha-container" data-callback="callback"></div>
        </div>
        <div class="flex w-full">
          <p
            class="pointer cancel-button"
            *ngIf="isDesktop && isEditPhoneMode"
            (click)="closeDialogs()"
          >
            Cancel
          </p>
          <button
            class="button primary-button w-full phone-verification-button pointer"
            type="submit"
            [class.disabled]="isDisabled()"
          >
            Get Code
          </button>
        </div>
        <a
          class="back-step"
          [routerLink]="['/authenticate', 'login']"
          *ngIf="!isEditPhoneMode"
          >Back To Login</a
        >
      </form>
    </div>
    <div *ngIf="isVerificationStep" class="verification-step">
      <div class="title flex">
        <p>{{ countryField }}-{{ numberField | phoneNumber }}</p>
        <img
          src="assets/images/icons/edit-line.svg"
          alt=""
          class="pointer"
          (click)="getBackToSubmitPhone()"
        />
      </div>
      <form
        [formGroup]="verificationCodeForm"
        class="otp-form flex"
        (paste)="handlePaste($event)"
      >
        <mat-form-field floatLabel="never">
          <input
            matInput
            maxlength="1"
            type="number"
            onlyNumbers
            pattern="[0-9]*"
            formControlName="character1"
            class="otp otp-1"
            #character1
            (keyup)="onSwitchInput($event, null, character1, character2, 1)"
            [class.invalid-code]="
              verificationCodeForm.get('character1').invalid || isOtpCodeInvalid
            "
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            matInput
            maxlength="1"
            type="number"
            onlyNumbers
            pattern="[0-9]*"
            class="otp otp-2"
            formControlName="character2"
            #character2
            (keyup)="
              onSwitchInput($event, character1, character2, character3, 2)
            "
            [class.invalid-code]="
              verificationCodeForm.get('character2').invalid || isOtpCodeInvalid
            "
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            matInput
            maxlength="1"
            type="number"
            onlyNumbers
            pattern="[0-9]*"
            class="otp otp-3"
            formControlName="character3"
            #character3
            (keyup)="
              onSwitchInput($event, character2, character3, character4, 3)
            "
            [class.invalid-code]="
              verificationCodeForm.get('character3').invalid || isOtpCodeInvalid
            "
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            matInput
            maxlength="1"
            type="number"
            onlyNumbers
            pattern="[0-9]*"
            class="otp otp-4"
            formControlName="character4"
            #character4
            (keyup)="
              onSwitchInput($event, character3, character4, character5, 4)
            "
            [class.invalid-code]="
              verificationCodeForm.get('character4').invalid || isOtpCodeInvalid
            "
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            matInput
            maxlength="1"
            type="number"
            onlyNumbers
            pattern="[0-9]*"
            class="otp otp-5"
            formControlName="character5"
            #character5
            (keyup)="
              onSwitchInput($event, character4, character5, character6, 5)
            "
            [class.invalid-code]="
              verificationCodeForm.get('character5').invalid || isOtpCodeInvalid
            "
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            matInput
            maxlength="1"
            type="number"
            onlyNumbers
            pattern="[0-9]*"
            class="otp otp-6"
            formControlName="character6"
            #character6
            (keyup)="onSwitchInput($event, character5, character6, null, 6)"
            [class.invalid-code]="
              verificationCodeForm.get('character6').invalid || isOtpCodeInvalid
            "
          />
        </mat-form-field>
      </form>
      <div class="remaining-time" hidden [class.flex]="isVerificationStep">
        <div
          class="countdown-finished-message flex"
          *ngIf="remainingTime.timer < 1"
        >
          <p class="notification">Didn’t Receive The Code</p>
          <p class="resend-code-action pointer" (click)="resendCode()">
            Resend Code
          </p>
        </div>
        <ng-container *ngIf="remainingTime.timer > 1">
          <p class="verify-text">
            {{
              isEditPhoneMode
                ? "We've sent you a verification code"
                : 'Verification Code Sent'
            }}
          </p>
          <div class="circle-timer">
            <svg>
              <circle cx="30" cy="30" r="30"></circle>
              <circle cx="30" cy="30" r="30" #stroke></circle>
            </svg>
            <div class="seconds">
              <p>{{ remainingTime.minutes }}</p>
              :
              <p>{{ remainingTime.seconds }}</p>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="resend-code" *ngIf="remainingTime.timer <= 1">
        <div id="recaptcha-resend"></div>
      </div>
      <div class="w-full flex">
        <p
          class="pointer cancel-button"
          *ngIf="isDesktop && isEditPhoneMode"
          (click)="closeDialogs()"
        >
          Cancel
        </p>
        <button
          class="submit-button submit-phone button primary-button w-full"
          [class.edit-desktop]="isDesktop && isEditPhoneMode"
          type="submit"
          (click)="onSubmitCode()"
          [class.disabled]="isVerificationStepDisabled()"
        >
          {{ isEditPhoneMode ? 'Change Number' : 'Log In' }}
        </button>
      </div>
    </div>
  </div>
</div>
